export function countRecaneGroups(
  recaneEmbryos:
    | Array<{
        name?: string | null;
        cane?: string | null;
        creation?: string | null;
      }>
    | null
    | undefined,
): number {
  if (!Array.isArray(recaneEmbryos)) return 0;
  const groups = new Set(
    recaneEmbryos.map(
      (e) => `${e.name ?? ''}|${e.cane ?? ''}|${e.creation ?? ''}`,
    ),
  );
  return groups.size;
}
